var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColab1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.39 20.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212322;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.85,
    y: 3.73,
    width: 3.74,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.19,3.73V0H0v3.74h9.23v16.8h3.74V3.74h9.23v3.73h11.1l.6.63v2.07s-9.55,0-9.55,0c-2.86,0-5.18,2.32-5.18,5.18s2.32,5.18,5.18,5.18h6.98l2.58-2.07v2.06s3.73,0,3.73,0V6.6l-2.74-2.87h-12.7Zm9.07,13.05v.02h-6.93c-.8,0-1.44-.65-1.44-1.44s.65-1.44,1.44-1.44h9.56v1.61l-2.63,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.99,3.73v3.74h11.1l.6.63v2.07s-9.55,0-9.55,0c-2.86,0-5.18,2.32-5.18,5.18s2.32,5.18,5.18,5.18h6.98l2.58-2.07v2.06s3.73,0,3.73,0V6.6l-2.74-2.87h-12.7Zm9.07,13.05v.02h-6.93c-.8,0-1.44-.65-1.44-1.44s.65-1.44,1.44-1.44h9.56v1.61l-2.63,1.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.7,
    y: 16.84,
    width: 3.69,
    height: 3.69
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColab1);
export default __webpack_public_path__ + "static/media/colab1.3b8279a239d023dbdf6cdc13b439f8c4.svg";
export { ForwardRef as ReactComponent };